export var QuestionContentAlignment;
(function (QuestionContentAlignment) {
    QuestionContentAlignment[QuestionContentAlignment["Center"] = 10] = "Center";
    QuestionContentAlignment[QuestionContentAlignment["Left"] = 20] = "Left";
})(QuestionContentAlignment || (QuestionContentAlignment = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["Numeric"] = 10] = "Numeric";
    QuestionType[QuestionType["Text"] = 20] = "Text";
    QuestionType[QuestionType["Toggle"] = 30] = "Toggle";
    QuestionType[QuestionType["Choose"] = 40] = "Choose";
})(QuestionType || (QuestionType = {}));
export var QuestionDisplayMode;
(function (QuestionDisplayMode) {
    QuestionDisplayMode[QuestionDisplayMode["PlusMinusButtons"] = 10] = "PlusMinusButtons";
    QuestionDisplayMode[QuestionDisplayMode["NumberInput"] = 20] = "NumberInput";
    QuestionDisplayMode[QuestionDisplayMode["TextInput"] = 30] = "TextInput";
    QuestionDisplayMode[QuestionDisplayMode["Checkbox"] = 40] = "Checkbox";
    QuestionDisplayMode[QuestionDisplayMode["Switch"] = 50] = "Switch";
    QuestionDisplayMode[QuestionDisplayMode["Dropdown"] = 60] = "Dropdown";
    QuestionDisplayMode[QuestionDisplayMode["Buttons"] = 70] = "Buttons";
})(QuestionDisplayMode || (QuestionDisplayMode = {}));
